import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { Alert } from "rsuite";
import constants from "../constants";
import RbacFolder from "./rbacfolder/rbacfolder";

const RbacModal = ({
  openForm,
  onCancel,
  folders_accessible,
  folder_structure,
  default_folder,
  selectedFolder
}) => {
  const [selected_folder, setSelectedFolder] = useState([]);

  useEffect(() => {
    console.log("default_folder props:", default_folder);
    setSelectedFolder([default_folder]);
  }, [default_folder]);

  const onOk = () => {
    if (!selected_folder || !selected_folder.length > 0) {
      Alert.error("Folder is mandatory.", constants.alertDuration);
    } else {
      selectedFolder(selected_folder);
      onCancel();
    }
  };

  const handleSelectedFolder = (selectedKeys) => {
    setSelectedFolder(selectedKeys);
  };

  return (
    <Modal
      open={openForm}
      onCancel={onCancel}
      onOk={onOk}
    >
      <h3 className="semi-header">Select Folder</h3>
      <RbacFolder
        selectedFolder={handleSelectedFolder}
        folder_structure={folder_structure}
        folders_accessible={folders_accessible}
        default_folder={default_folder}
      />
    </Modal>
  );
};

export default RbacModal;
